import React from 'react';
import { MenuItem, TextField } from '@material-ui/core';
import TranslationHelper from '../../../../helpers/TranslationHelper';
import { useStyles } from '../../Themable.hooks';

interface IOwnProps {
    label: string;
    typeInput: {
        type: string;
        setType: (value: string) => void;
    };
    types: string[];
}

export const TypeFilter = ({ label, typeInput, types }: IOwnProps) => {
    const classes = useStyles();
    return (
        <TextField
            select
            label={TranslationHelper.translate(label)}
            value={typeInput.type}
            onChange={(e) => typeInput.setType(e.target.value)}
            className={classes.selectType}
        >
            {types.map((option) => (
                <MenuItem key={option} value={option}>
                    {TranslationHelper.translate(`assignType.${option}`)}
                </MenuItem>
            ))}
        </TextField>
    );
};
